<script>
	import Helper from '../../Classes/Helper';
	import Preference from '../../Stores/Preference';
	import Product from '../../Stores/Product';
	import Registry from '../../Stores/Registry';
	import Widget from '../../Stores/Widget';
	import {onMount} from 'svelte';

	export let config;
	let element = {};
	let swipe = {};

	function getSelected(option) {
		let label = option.label;
		if (option.description) label += ` - ${option.description}`;
		const selected = {
			label,
			value: option.value,
			upgrade: option.upgrade,
			price: option.price || Product.variationPercentage(option.percentage),
			state: 'success',
			valid: true
		};

		return selected;
	}

	async function onClick(option) {
		if (config.on_click) {
			const selected = getSelected(option);
			config.on_click(selected, option);
			await Preference.setValue(option.label);
		}
	}

	async function preference() {
		let active = false; for (let option of config.options)
			if (option.active) { active = true; break; }

		if (!active) {
			const value = await Preference.getValue();
			const node = jQuery(element).find(`div[data-label="${value}"]`);
			if (node.length) {
				const event = new window.Event('click');
				node[0].dispatchEvent(event);
			}
		}
	}

	function swiper() {
		const onTouchStart = event => {
			element.removeEventListener('touchstart', onTouchStart);
			$Registry.unswipe_color = true;
		};

		element.addEventListener('touchstart', onTouchStart);
	}

	async function mount() {
		await preference();
		if (!$Registry.unswipe_color) swiper();
	}

	$: if (config.active) $Widget.current = element;
	onMount(mount);
</script>

<style>
	div.zes-colors {
		display: grid;
		grid-template-columns: repeat(auto-fill, minmax(7em, 1fr));
		gap: .65em;
		margin-bottom: 1.5em;
	}

	div.zes-colors div.zes-image {
		text-align: center;
		position: relative;
		padding: .25em;
		border: 1px solid hsl(0deg 0% 0% / .2);
		border-radius: .3em;
		cursor: pointer;
	}

	div.zes-colors div.zes-image:hover {
		border-color: var(--zes-1-3);
	}

	div.zes-colors div.zes-image.zes-active {
		border-color: var(--zes-1-3);
		box-shadow: 0 0 .5em 0 var(--zes-1-3);
		background: #FFF;
		z-index: 5;
		animation: colorActive 1s ease-in-out;
	}

	div.zes-colors div.zes-image div {
		font-size: .75em;
		font-weight: 600;
		text-shadow: 1px 1px 0 hsl(0deg 0% 0% / .5);
		color: hsl(0deg 100% 100%);
		width: 100%;
		height: 100%;
		padding: 1.5em 0;
		border-radius: .3em;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		background-size: cover;
		background-repeat: no-repeat;
	}

	div.zes-colors div.zes-image div span {
		font-weight: normal;
		font-size: .9em;
    	margin-top: .5em;
	}

	div.zes-colors div.zes-image div span:empty {
		display: none;
	}

	@keyframes colorActive {
		0% { transform: scale(1); }
		50% { transform: scale(1.75); }
		100% { transform: scale(1); }
	}

	/* Swipe */

	div.zes-swipe {
		position: absolute;
		left: calc(50% - 4em);
		z-index: 20;
		animation: swipeUpDown 3s ease-in-out infinite alternate;
		will-change: opacity;
		display: none;
	}

	div.zes-swipe i {
		font-size: 10em;
		color: #FFF;
		text-shadow: 0 0 .5rem hsla(0, 0%, 0%, .5);
	}

	@keyframes swipeUpDown {
		0% { transform: translateY(0); }
		50% { transform: translateY(3em); }
		100% { transform: translateY(0); }
	}

	/* Responsive */

	@media only screen and (max-width: 1024px) and (orientation: portrait) {
		div.zes-swipe {
			display: block;
		}
	}
</style>

<div bind:this="{element}" class="zes-colors">
	{#if !$Registry.unswipe_color}
		<div bind:this="{swipe}" class="zes-swipe">
			<i class="fa-duotone fa-arrows-up-down fa-rotate-180"></i>
		</div>
	{/if}
	{#each config.options as option}
		<div on:click="{event => onClick(option)}" class:zes-active="{option.active}" class="zes-image" data-label="{option.label}">
			<div style="background-image: url('{Helper.image(option.image)}')">
				{option.label}
				<span>{option.description}</span>
			</div>
		</div>
	{/each}
</div>